import { render } from "./ManitobaImportPop.vue?vue&type=template&id=1b8e9d70"
import script from "./ManitobaImportPop.vue?vue&type=script&lang=js"
export * from "./ManitobaImportPop.vue?vue&type=script&lang=js"

import "./ManitobaImportPop.vue?vue&type=style&index=0&id=1b8e9d70&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__